module.exports = __webpack_public_path__ + "img/login-v2.1f35be5e.jpg";